import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { LanguageService } from "../../service/language/language.service";
import { ILanguageCodeValue } from "../../pipes/localized/localized.interface";
import { ICheckboxFieldSpecs } from "../../module/formbuilder/fields/interfaces/field-specs";
import { FormControl, FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { IShowCondition, INoteForm, ICheckNote } from "../../interfaces/i-iaqoboh-reservation-form-config"



@Component({
    selector: 'check-note',
    template: `
        <ng-container *ngIf="formGroup && checkboxFieldsConfig?.length">
            <ng-container *ngFor="let checkboxField of checkboxFieldsConfig; let i = index;">
                <div class="checkboxField">
                    <checkbox-field [fieldConfig]="checkboxField"></checkbox-field>
                </div>
            </ng-container>
        </ng-container>
    `,
    styleUrls: ['./check-note.component.scss'],
})
export class CheckNoteComponent implements OnInit, OnDestroy {

    @Input()
    public servicesFormConfiguration: INoteForm;
    @Output()
    public readonly onCheckedEvent: EventEmitter<string[]> = new EventEmitter<string[]>();

    public locale: string;
    public checkNotes: ICheckNote[];
    public formGroup: FormGroup;
    public checkboxFieldsConfig: ICheckboxFieldSpecs[];
    private formChangeSubscription: Subscription;

    constructor(private readonly languageService: LanguageService) {
        this.locale = languageService.getUserLanguage();
    }

    public ngOnInit(): void {
        this.initCheckNotes();
        if (this.checkNotes.length) {
            this.initFormGroup();
            this.initCheckboxFieldsConfig();
            this.initFormChangeSubscription();
        }
    }

    public ngOnDestroy(): void {
        if (this.formChangeSubscription) {
            this.formChangeSubscription.unsubscribe();
        }
    }

    private initCheckNotes(): void {
        this.checkNotes = this.servicesFormConfiguration.checkboxArray?.map((note: ICheckNote, index: number): ICheckNote => {
            return {
                ...note,
                label: this.getLabel(note),
                code: `note${index}`,
            };
        }) ?? [];
    }

    private getLabel(note: ICheckNote): string {
        const labelByLanguage: ILanguageCodeValue = note.labelArray?.find((label: ILanguageCodeValue): boolean => label.languageCode === this.locale);
        return labelByLanguage ? labelByLanguage.value : note.labelArray?.length ? note.labelArray[0].value : '';
    }

    private initFormGroup(): void {
        const controls: { [key: string]: FormControl } = {};
        this.checkNotes.forEach((checkNote: ICheckNote): void => {
            controls[checkNote.code] = new FormControl(false);
        });
        this.formGroup = new FormGroup(controls);
    }

    private initCheckboxFieldsConfig(): void {
        this.checkboxFieldsConfig = this.checkNotes.map((checkNote: ICheckNote): ICheckboxFieldSpecs => {
            return {
                formControlName: checkNote.code,
                formGroup: this.formGroup,
                checkboxLabel: checkNote.label
            };
        });
    }

    private initFormChangeSubscription(): void {
        this.formChangeSubscription = this.formGroup.valueChanges
            .subscribe((event: { [key: string]: boolean }): void => {
                const checkedValues: string[] = Object.entries(event)
                    .filter(([key, value]: [string, boolean]): boolean => value)
                    .map(([key, value]: [string, boolean]): string => {
                        return this.checkNotes.find((note: ICheckNote): boolean => note.code === key).value;
                    });
                this.onCheckedEvent.emit(checkedValues);
            });
    }
}
